module.exports = __webpack_public_path__ + "img/survey-is-saved.6fc0f09d.svg";